"use client";

import { motion } from "framer-motion";

export default function HeroSection() {
  return (
    <div className="relative overflow-hidden hero-font mt-0  sm:mt-10">

      {/* ANIMATED BACKGROUND */}
      <motion.div
        className="absolute inset-0 bg-cover blur-[5px] bg-center scale-110"
        style={{
          backgroundImage:
            "url('https://plus.unsplash.com/premium_photo-1664301972519-506636f0245d?w=1600&auto=format&fit=crop&q=80')",
        }}
        animate={{
          scale: [1.1, 1.2, 1.1],
          x: [0, -10, 0],
          y: [0, -10, 0],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      {/* DARK OVERLAY */}
      <div className="absolute inset-0 bg-black/60" />

      {/* CONTENT CENTER FIX */}
      <section className="relative z-10 flex items-center justify-center min-h-screen px-4">

        <div className="max-w-3xl text-center text-white flex flex-col items-center justify-center">

          {/* Label */}
          <motion.p
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-sm tracking-widest text-gray-200 uppercase"
          >
            Since 1989
          </motion.p>

          {/* Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight"
          >
            Reliable HVAC & Refrigeration{" "}
            <span className="text-blue-400">
              Solutions Across Pakistan
            </span>
          </motion.h1>

          {/* Paragraph */}
          <motion.p
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="mt-5 text-gray-200 text-sm sm:text-base leading-relaxed max-w-2xl"
          >
            Delivering expert installation, maintenance, and repair services for
            commercial and residential air conditioning systems. Built on trust,
            powered by experience.
          </motion.p>

          {/* Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2 }}
            className="mt-8 flex flex-col sm:flex-row gap-4"
          >
            <a
              href="https://api.whatsapp.com/send?phone=923214435667"
              target="_blank"
              className="px-24 py-3 sm:px-8 sm:py-3 rounded-xl bg-[#1f4ba5] hover:bg-blue-700 transition font-medium"
            >
              Get a Free Consultation
            </a>

            <a
              href="https://api.whatsapp.com/send?phone=923214435667"
              target="_blank"
              className="px-8 py-3 rounded-xl border border-white/60 hover:bg-white hover:text-black transition font-medium"
            >
              View Projects
            </a>
          </motion.div>

        </div>
      </section>
    </div>
  );
}